export default __webpack_public_path__ + "static/media/clarity-si1.5d8fa9ca.webp";